import {
  ApolloError,
  MutationHookOptions,
  gql,
  useMutation,
} from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';
import {
  SetDefaultBuildPipelineTrack,
  SetDefaultBuildPipelineTrackVariables,
} from 'src/lib/graphqlTypes/types';

const SET_DEFAULT_BUILD_PIPELINE_TRACK = gql<
  SetDefaultBuildPipelineTrack,
  SetDefaultBuildPipelineTrackVariables
>`
  mutation SetDefaultBuildPipelineTrack($graphId: ID!, $version: String!) {
    graph(id: $graphId) {
      setDefaultBuildPipelineTrack(version: $version)
    }
  }
`;

export const useSetDefaultBuildPipelineTrack = (
  options?: MutationHookOptions<
    SetDefaultBuildPipelineTrack,
    SetDefaultBuildPipelineTrackVariables
  >,
): [
  ({
    variables,
  }: {
    variables: SetDefaultBuildPipelineTrackVariables;
  }) => Promise<void>,
  {
    loading: boolean;
    error: ApolloError | undefined;
    data: GraphQLTypes.SetDefaultBuildPipelineTrack | null | undefined;
  },
] => {
  const [setDefaultBuildPipelineTrack, { loading, error, data }] = useMutation(
    SET_DEFAULT_BUILD_PIPELINE_TRACK,
    options,
  );

  const handleSetDefaultBuildPipelineTrack = async ({
    variables,
  }: {
    variables: SetDefaultBuildPipelineTrackVariables;
  }) => {
    const version =
      variables?.version === GraphQLTypes.BuildPipelineTrack.FED_NEXT ||
      variables?.version === 'FED_NEXT'
        ? 'FED_NEXT'
        : variables?.version?.replace('FED_', '').replace('_', '.') || '2.11';
    setDefaultBuildPipelineTrack({
      variables: { ...variables, version },
    });
  };

  return [handleSetDefaultBuildPipelineTrack, { loading, error, data }];
};
